import React, { createRef, Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import DataHandler from 'atpjs/data_handler'
import { findDocuments } from 'atpjs/helpers/document'
import { fileListToArray } from 'atpjs/helpers/file'
import DocumentListItem from 'tve/components/document_list/item'
import { uploadDocument, deleteDocument } from 'tve/helpers/documents'

const contentTypes = ['application/pdf', 'image/jpg', 'image/jpeg', 'image/png']
const meta = { field: 'uploaded_documents' }

class DocumentList extends Component {
  static propTypes = {
    data: PropTypes.instanceOf(DataHandler)
  }

  fileInput = createRef()

  fileSelectHandler = (event) => {
    const { data } = this.props
    fileListToArray(event.target.files).map((file) => {
      uploadDocument(data)(file, meta)
    })
    event.target.value = ''
  }

  uploadFileHandler = (_event) => {
    this.fileInput.current.click()
  }

  render() {
    const { data } = this.props
    const documents = findDocuments(data.get('documents'))(meta)
    return (
      <Fragment>
        {documents.size > 0 && (
          <div className="atp-summary__document">
            {documents.map((document) => {
              return (
                <DocumentListItem key={document.get('id')} document={document} deleteHandler={deleteDocument(data)} />
              )
            })}
          </div>
        )}
        <button
          className="atp-btn atp-btn--right-icon atp-btn--icon-add atp-margin-top-xs"
          onClick={this.uploadFileHandler}>
          Dokument hochladen
        </button>
        <input
          ref={this.fileInput}
          type="file"
          style={{ display: 'none' }}
          onChange={this.fileSelectHandler}
          multiple
          accept={contentTypes.join(', ')}
        />
      </Fragment>
    )
  }
}

export default DocumentList
